import React, {useState, useEffect} from "react";
import StyledRadarChart from "../forms/RadarChart";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import {API_URL} from "../../App";


const getIconPath = (coachInfo) => {
  if (coachInfo==null){
    return "";
  }
  return `/icons/${coachInfo.character}_${coachInfo.costume_id}.webp`;
};


const BotInfo = ({ botInfo }) => {
  const navigate = useNavigate();

  const [coachInfo, setCoachInfo] = useState({})
  
  const {
    bot,
    metrics
  } = botInfo;

  useEffect(() => {
    const fetchCoachInfo = async () => {
      if (metrics.coach_tag != null) {
        try {
          const response = await axios.get(`${API_URL}/api/bot-info/${metrics.coach_tag}`);
          setCoachInfo(response.data)
        } catch (error) {
            //console.error("Failed to fetch bot from tag", error);
        }
      }
    };
    fetchCoachInfo();
    
  }, [metrics.coach_tag]);


  return (
<div className="py-4 px-6 justify-center items-start relative grid grid-cols-1 md:grid-cols-2 gap-6 py-2">
  {/* Left Side - Character Image */}
  <div className="grid grid-cols-1 gap-4 col-span-1 flex flex-col justify-start items-center">
    {/* Character Section */}
    <div className="flex flex-col items-center space-y-2">
      <h3 className="text-lg font-semibold">Main</h3>
      <div className="w-48 flex justify-center items-center bg-gray-500/10 rounded-lg p-0">
        <img
          src={`/splasharts/${bot.character}_${bot.costume_id}.webp`} // Character splash art
          alt=""
          className="w-48 object-cover rounded-lg shadow-lg"
        />
      </div>
    </div>
  </div>

  {/* Right Side - Bot Details */}
  <div className="col-span-1 flex flex-col space-y-2 justify-start items-center">

    {/* Preferred Stage */}
    <div className="flex flex-col items-center space-y-2">
      <h3 className="text-lg font-semibold">Preferred Stage</h3>
      <img
        src={`/stages/STAGE_${bot.preferred_stage_index}.webp`} // Stage image
        alt=""
        className="h-52 w-52 object-cover rounded-lg shadow-lg"
      />
    </div>

    {/* Preferred Move*/}
    <div className="flex flex-col items-center pt-3">
      <div>
        <h3 className="text-lg">Preferred Move</h3>
        <p className="text-sm text-gray-400">{bot.preferred_move}</p>
      </div>
    </div>
  </div>

  {/* Radar Chart Section */}
  <div className="col-span-2 md:col-span-2 flex flex-col justify-start items-center space-y-4 w-full">
    <div className="flex flex-row space-x-4 justify-start items-start w-full">
      {/* Stat Values on the Left */}
      <div className="flex flex-col space-y-2 justify-start items-center w-full">
        <h3 className="text-lg font-semibold text-center w-32 mt-4 mb-4">Stats</h3>

        {bot.stats && Object.keys(bot.stats).map((statKey) => (
          <div key={statKey} className="flex items-baseline justify-center w-full">
            {/* Stat Name */}
            <div className="w-32 text-sm text-gray-400 font-medium">{statKey}</div>
            {/* Stat Value */}
            <div className="pl-2 text-sm text-gray-100">{bot.stats[statKey]}</div>
          </div>
        ))}

        {/* Coach Section */}
        {metrics.coach_tag && coachInfo && (
          <div className="flex justify-center w-full py-1">
            <button
              className="flex flex-col items-center space-y-2 bg-pink-300/10 border border-pink-300/30 rounded-lg hover:border-pink-300 p-1 w-max duration-200 ease-in-out"
              onClick={() => navigate(`/profiles/${coachInfo.bot.twitch_display_name}/${metrics.coach_tag}`)}
            >
              <h3 className="text-lg font-semibold text-center w-16">Coach</h3>
              <div className="flex items-center w-full px-2">
                <img
                  src={getIconPath(coachInfo.bot)}
                  alt=""
                  className="w-5 h-5 rounded-full mr-2"
                />
                <span className="text-gray-300 truncate w-20">{metrics.coach_tag}</span>
              </div>
            </button>
          </div>
        )}
      </div>

      {/* Radar Chart */}
      <div className="flex justify-center items-start w-full">
        <StyledRadarChart stats={bot.stats} width={300} height={300} />
      </div>
    </div>
  </div>
</div>

  );
};

export default BotInfo;
